module.exports = __webpack_public_path__ + "img/icon1.49b6b620.svg";